export default function () {
    return {
        peerreviews: {}
    };
}
